module.exports = {"TXTWCL_WeXre_working_on_this":{"id":"TXTWCL_WeXre_working_on_this","defaultMessage":"Estamos trabalhando nisso"}}